var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21018 12.5472C2.88898 12.7086 2.52529 12.4266 2.58995 12.0662L3.2796 8.22353L0.351916 5.49625C0.0783086 5.24138 0.219942 4.77536 0.586482 4.72446L4.65799 4.15906L6.47338 0.643748C6.63691 0.327084 7.07991 0.327084 7.24344 0.643748L9.05883 4.15906L13.1303 4.72446C13.4969 4.77536 13.6385 5.24138 13.3649 5.49625L10.4372 8.22353L11.1269 12.0662C11.1915 12.4266 10.8278 12.7086 10.5066 12.5472L6.85841 10.7143L3.21018 12.5472Z",
    fill: "#ECAF2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryStar);
export default __webpack_public_path__ + "static/media/category-star.441045adc7afff2592e5f8898c8b7875.svg";
export { ForwardRef as ReactComponent };